import React from 'react';
import PropTypes from 'prop-types';
import ArticleView from 'epic-react-blog/app/scripts/views/ArticleView';

export default class ArticleWrapper extends React.Component {
    static propTypes = {
        params: PropTypes.object,
        router: PropTypes.object
    };

    render() {
        return (
            <div className="blog-wrapper">
                <ArticleView
                    rootPageSlug="news"
                    {...this.props} />
            </div>
        );
    }
}
